






































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class RisikoJatuh extends Vue {
  @Prop() setRisikoJatuh: string;
  // risikojatuh = "";
  @Watch("setRisikoJatuh")
  changeSetRisikoJatuh(v) {
    // this.risikojatuh = v;
    this.$emit("risikojatuh", v);
  }

  // @Watch("risikojatuh")
  // changeRisikoJatuh(v) {
  //   this.$emit("risikojatuh", v);
  // }
}
